import { FOLDER_TYPES } from 'lib/api/folders/getFoldersV2';
import { TFunction } from 'i18next';

export const DefaultFolderIds = {
  PRIMARY: -2,
  PRIVATE: -3,
  COMPANY: -1,
  VAULT: 0,
  LEARNING_OPPORTUNITIES: -4,
  SUPPORT_TRAINING: -5,
};

export const DEFAULT_COMPANY_FOLDER = 'Company';
export const SHARED_FOLDER_PREFIX = '~~shared~~';

export const ALL_FOLDERS_VALUE = '_all';

export const getAllFolders = (t: TFunction) => ({
  value: ALL_FOLDERS_VALUE,
  label: t('All Folders'),
});

export const DEFAULT_FOLDER = {
  folderId: -2,
  name: 'Primary',
  isDeletable: false,
  isFolderShared: false,
  userId: undefined,
  folderType: FOLDER_TYPES.PERSONAL,
  access: undefined,
};

export const SHARE_FOLDER_NOTIFY_CHECKBOX_LABEL =
  'Notify users who have access to this folder about the changes';

export const SHARED_BY_KEY = 'SHARED_BY_';
